import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { Image } from '../../common/components';
import { useMobile } from '../../common/hooks/use-mobile';
import { isClickable, transformInterval, transformPageMargins } from '../../common/utils';
import { Swiper } from './swiper';
import { useDesignContext } from '../../design-provider';
export var L1r3 = function L1r3(props) {
  var left1Images = props.left1Images,
    _props$left1Images = _slicedToArray(props.left1Images, 1),
    left1Image = _props$left1Images[0],
    _props$right1Images = _slicedToArray(props.right1Images, 1),
    right1Image = _props$right1Images[0],
    _props$right2Images = _slicedToArray(props.right2Images, 1),
    right2Image = _props$right2Images[0],
    _props$right3Images = _slicedToArray(props.right3Images, 1),
    right3Image = _props$right3Images[0],
    swiper = props.swiper,
    pagePadding = props.pagePadding,
    imageSpacing = props.imageSpacing;
  var mobile = useMobile();
  var _useDesignContext = useDesignContext(),
    designOnLink = _useDesignContext.designOnLink;
  return _jsxs("div", Object.assign({
    className: 'box-border grid grid-rows-4 grid-cols-4 mx-auto w-full max-w-pc max-h-[1080px]',
    style: {
      paddingLeft: transformPageMargins(pagePadding, mobile),
      paddingRight: transformPageMargins(pagePadding, mobile),
      gap: transformInterval(imageSpacing, mobile, 'photoAds')
    }
  }, {
    children: [_jsx("div", Object.assign({
      className: 'col-span-2 row-span-4'
    }, {
      children: swiper === 'open' && left1Images.length > 1 ? _jsx(Swiper, {
        className: 'w-full h-full',
        navigationClassName: 'w-full h-full',
        swiperCompClassName: 'w-full h-full',
        imageAdList: left1Images.map(function (left1Image) {
          return Object.assign(Object.assign({}, left1Image), {
            fileType: 'image'
          });
        }),
        interval: 5000,
        indicator: '3',
        imageRadius: 'rightAngle',
        effect: 'ease',
        objectFit: 'fill',
        arrow: 'close',
        pagePadding: 0
      }) : (left1Image === null || left1Image === void 0 ? void 0 : left1Image.fileValue) && _jsx("a", Object.assign({
        className: 'block w-full h-full',
        href: designOnLink(left1Image.target)
      }, {
        children: _jsx(Image, {
          className: 'w-full h-full',
          src: left1Image.fileValue
        })
      }))
    })), _jsx("div", Object.assign({
      className: 'col-span-2 row-span-2'
    }, {
      children: (right1Image === null || right1Image === void 0 ? void 0 : right1Image.fileValue) && _jsx("a", Object.assign({
        className: classNames('block w-full h-full', {
          'cursor-pointer': isClickable(right1Image.target)
        }),
        href: designOnLink(right1Image.target)
      }, {
        children: _jsx(Image, {
          className: classNames('w-full h-full', {
            'cursor-pointer': isClickable(right1Image.target)
          }),
          src: right1Image.fileValue
        })
      }))
    })), _jsx("div", Object.assign({
      className: 'col-span-1 row-span-2'
    }, {
      children: (right2Image === null || right2Image === void 0 ? void 0 : right2Image.fileValue) && _jsx("a", Object.assign({
        className: classNames('block w-full h-full', {
          'cursor-pointer': isClickable(right2Image.target)
        }),
        href: designOnLink(right2Image.target)
      }, {
        children: _jsx(Image, {
          className: classNames('w-full h-full', {
            'cursor-pointer': isClickable(right2Image.target)
          }),
          src: right2Image.fileValue
        })
      }))
    })), _jsx("div", Object.assign({
      className: 'col-span-1 row-span-2'
    }, {
      children: (right3Image === null || right3Image === void 0 ? void 0 : right3Image.fileValue) && _jsx("a", Object.assign({
        className: classNames('block w-full h-full', {
          'cursor-pointer': isClickable(right3Image.target)
        }),
        href: designOnLink(right3Image.target)
      }, {
        children: _jsx(Image, {
          className: classNames('w-full h-full', {
            'cursor-pointer': isClickable(right3Image.target)
          }),
          src: right3Image.fileValue
        })
      }))
    }))]
  }));
};